import { cn } from "@/lib/utils";

export function TabsV2<T extends string>({
  items,
  value,
  onChange,
}: {
  items: Array<{ label: string; value: T; description?: string }>;
  value: T;
  onChange: (_next: T) => void;
}) {
  const activeItem = items.find((item) => item.value === value);
  return (
    <div className="inline-flex flex-col gap-2">
      <div
        className="v2-panel inline-flex p-1"
        role="tablist"
        aria-label="Sekmeler"
      >
        {items.map((item) => {
          const active = item.value === value;
          return (
            <button
              key={item.value}
              className={cn(
                "v2-focus-ring rounded-[10px] px-3 py-2 text-sm font-semibold transition",
                active
                  ? "bg-[var(--v2-accent)] text-white"
                  : "text-[var(--v2-text-muted)] hover:bg-slate-100"
              )}
              role="tab"
              aria-selected={active}
              title={item.description}
              onClick={() => onChange(item.value)}
            >
              {item.label}
            </button>
          );
        })}
      </div>
      {activeItem?.description ? (
        <p className="max-w-3xl text-sm text-[var(--v2-text-muted)]">
          {activeItem.description}
        </p>
      ) : null}
    </div>
  );
}
